import React, { useState } from "react";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import ExpandLessIcon from "@material-ui/icons/ExpandLess";
import {
  Badge,
  Collapse,
  IconButton,
  Paper,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Chip,
  Grid,
} from "@material-ui/core";
import Icon from "@mdi/react";
import { mdiFilterVariantRemove, mdiFilterVariant } from "@mdi/js";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import TaxonomySelector from "./../taxonomy/TaxonomySelector";
import { useSelector } from "react-redux";
import DocumentCategories from "../document/DocumentCategories";
import SearchLanguages from "../search/SearchLanguages";
import { currentUserHasRole, Role } from "../../utils/RoleUtils";
import { useTranslation } from "react-i18next";
import ChipInput from "material-ui-chip-input";
import DocumentType from "../DocumentType";
import { DatePicker } from "@material-ui/pickers";
import Media from "react-media";
import { connect } from "react-redux";
const useStyles = makeStyles((theme) => ({
  paperRoot: {
    display: "flex",
    width: "100%",
    marginLeft: "auto",
    marginRight: "auto",
    flexDirection: "column",
    marginBottom: 10,
    paddingBottom: 5,
  },
  expandedContainer: {
    display: "flex",
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    flexWrap: "wrap",
  },
  notChips: {
    marginTop: 8,
  },
}));
const StyledBadge = withStyles((theme) => ({
  anchorOriginTopLeftRectangle: {
    transform: "translate(-150%, 50%)",
  },
}))(Badge);

function SearchFilters(props) {
  const [expanded, setExpanded] = useState(false);
  const classes = useStyles();
  const taxonomyNodeLookup = useSelector(
    (state) => state.taxonomy.taxonomyNodeLookup
  );
  const documentTypes = useSelector((state) => state.prefs.documentTypes);
  const { t } = useTranslation();

  const taxonomyFilter = (small) => {
    return (
      <FormControl
        className={classes.notChips}
        // style={small ? { width: "100%" } : {}}
      >
        {props.isFilterSet("taxonomy") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <TaxonomySelector
          limitWithTeam
          id="search-filters-taxonomy-selector"
          multiSelect
          allowedSelections={["taxonomy", "topic"]}
          filter={
            props.filters.taxonomy ? props.filters.taxonomy : taxonomyNodeLookup
          }
          onNodeSelected={props.onTaxonomyChange}
        />
      </FormControl>
    );
  };

  const categoriesFilter = (small) => {
    return (
      <FormControl
        className={classes.notChips}
        style={{ width: small &&  "182px", minWidth: props.isMobile && "202px" }}
      >
        {props.isFilterSet("categories") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <DocumentCategories
          mobile={small}
          onChange={(c) =>
            props.onChange({
              target: { name: "categories", value: c.map((c) => c.id) },
            })
          }
        />
      </FormControl>
    );
  };

  const liveDraftFilter = (small) => {
    return (
      <>
        {(currentUserHasRole(Role.BE_EXPERT) ||
          currentUserHasRole(Role.SYSTEM_MANAGER)) && (
          <FormControl
            className={classes.notChips}
            style={{ width: small && "182px", minWidth: props.isMobile && "202px"  }}
          >
            {props.isFilterSet("liveDraftMode") && (
              <StyledBadge
                color="secondary"
                variant="dot"
                anchorOrigin={{
                  vertical: "top",
                  horizontal: "left",
                }}
              />
            )}
            <InputLabel id="live-draft">
              {t("search_bar_live_draft")}
            </InputLabel>
            <Select
              autoWidth
              MenuProps={{
                style: { zIndex: 35001 },
              }}
              id="search-filters-live-draft"
              labelId="live-draft"
              value={props.filters.liveDraftMode}
              onChange={props.onChange}
              inputProps={{
                name: "liveDraftMode",
              }}
              style={{ width: "100%" }}
            >
              <MenuItem value={"All"}>{t("global_all")}</MenuItem>
              <MenuItem value={"Live"}>{t("global_document_live")}</MenuItem>
              <MenuItem value={"Draft"}>{t("global_document_draft")}</MenuItem>
            </Select>
          </FormControl>
        )}
      </>
    );
  };

  const languagesFilter = (small) => {
    return (
      <FormControl
        className={classes.notChips}
        style={small ? { width: "182px" } : {}}
      >
        {props.isFilterSet("languages") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <SearchLanguages
          mobile={small}
          value={props.filters.languages}
          onChange={(l) =>
            props.onChange({ target: { name: "languages", value: l } })
          }
        />
      </FormControl>
    );
  };

  const documentTypeFilter = (small) => {
    return (
      <FormControl className={classes.notChips}>
        {props.isFilterSet("documentTypes") && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <DocumentType
          id="search-filters-document-type"
          search
          multiSelect={true}
          doctypes={documentTypes}
          docTypeSelected={props.handleSelectChange}
          documentType={props.filters.documentTypes}
        />
      </FormControl>
    );
  };

  const anyWordExact = () => {
    return (
      <FormControl className={classes.formControl}>
        {props.filters.anyWordExact &&
          props.filters.anyWordExact.length > 0 && (
            <StyledBadge
              color="secondary"
              variant="dot"
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            />
          )}
        <ChipInput
          id="search-filter-any-words"
          classes={{ root: classes.chipInput }}
          fullWidthInput={false}
          value={
            props.filters.anyWordExact ? [...props.filters.anyWordExact] : []
          }
          onAdd={(chip) => props.addChip("anyWordExact", chip)}
          onDelete={(chip) => props.deleteChip("anyWordExact", chip)}
          newChipKeyCodes={[9, 13, 32]}
          margin="none"
          chipRenderer={(
            { text, handleDelete, isDisabled, className },
            key
          ) => {
            return (
              <Chip
                label={text}
                onDelete={handleDelete}
                disabled={isDisabled}
                size="small"
                key={key}
                className={className}
              />
            );
          }}
          label={t("search_bar_any_words")}
        />
      </FormControl>
    );
  };

  const createdDateRangeStart = () => {
    return (
      <FormControl className={classes.notChips}>
        {props.filters.createdDateRangeStart && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <DatePicker
          id="search-filter-created-from"
          autoOk
          label={t("search_bar_created_from")}
          clearable
          disableFuture
          value={props.filters.createdDateRangeStart || null}
          onChange={props.handleDateChange("createdDateRangeStart")}
        />
      </FormControl>
    );
  };
  const createdDateRangeEnd = () => {
    return (
      <FormControl className={classes.notChips}>
        {props.filters.createdDateRangeEnd && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <DatePicker
          id="search-filter-created-to"
          autoOk
          label={t("search_bar_created_to")}
          clearable
          disableFuture
          value={props.filters.createdDateRangeEnd || null}
          onChange={props.handleDateChange("createdDateRangeEnd")}
        />
      </FormControl>
    );
  };
  const lastModifiedDateRangeStart = () => {
    return (
      <FormControl className={classes.notChips}>
        {props.filters.lastModifiedDateRangeStart && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <DatePicker
          id="search-filter-updated-from"
          autoOk
          label={t("search_bar_updated_from")}
          clearable
          disableFuture
          value={props.filters.lastModifiedDateRangeStart || null}
          onChange={props.handleDateChange("lastModifiedDateRangeStart")}
        />
      </FormControl>
    );
  };
  const lastModifiedDateRangeEnd = () => {
    return (
      <FormControl className={classes.notChips}>
        {props.filters.lastModifiedDateRangeEnd && (
          <StyledBadge
            color="secondary"
            variant="dot"
            anchorOrigin={{
              vertical: "top",
              horizontal: "left",
            }}
          />
        )}
        <DatePicker
          id="search-filter-updated-to"
          autoOk
          label={t("search_bar_updated_to")}
          clearable
          disableFuture
          value={props.filters.lastModifiedDateRangeEnd || null}
          onChange={props.handleDateChange("lastModifiedDateRangeEnd")}
        />
      </FormControl>
    );
  };
  const allWordExact = () => {
    return (
      <FormControl className={classes.formControlChip}>
        {props.filters.allWordExact &&
          props.filters.allWordExact.length > 0 && (
            <StyledBadge
              color="secondary"
              variant="dot"
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            />
          )}
        <ChipInput
          id="search-filter-all-words"
          className={classes.chipInput}
          size="small"
          fullWidthInput={false}
          value={
            props.filters.allWordExact ? [...props.filters.allWordExact] : []
          }
          onAdd={(chip) => props.addChip("allWordExact", chip)}
          onDelete={(chip) => props.deleteChip("allWordExact", chip)}
          newChipKeyCodes={[9, 13, 32]}
          label={t("search_bar_all_words")}
        />
      </FormControl>
    );
  };
  const exactPhrase = () => {
    return (
      <FormControl className={classes.formControlChip}>
        {props.filters.exactPhrase &&
          props.filters.exactPhrase.length > 0 && (
            <StyledBadge
              color="secondary"
              variant="dot"
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            />
          )}
        <ChipInput
          id="search-filter-exact-phrase"
          className={classes.chipInput}
          fullWidthInput={false}
          size="small"
          value={
            props.filters.exactPhrase ? [...props.filters.exactPhrase] : []
          }
          onAdd={(chip) => props.addChip("exactPhrase", chip)}
          onDelete={(chip) => props.deleteChip("exactPhrase", chip)}
          newChipKeyCodes={[9, 13]}
          label={t("search_bar_exact_phrase")}
        />
      </FormControl>
    );
  };
  const noWordExact = () => {
    return (
      <FormControl className={classes.formControlChip}>
        {props.filters.noWordExact &&
          props.filters.noWordExact.length > 0 && (
            <StyledBadge
              color="secondary"
              variant="dot"
              anchorOrigin={{
                vertical: "top",
                horizontal: "left",
              }}
            />
          )}
        <ChipInput
          id="search-filter-no-words"
          size="small"
          className={classes.chipInput}
          value={
            props.filters.noWordExact ? [...props.filters.noWordExact] : []
          }
          onAdd={(chip) => props.addChip("noWordExact", chip)}
          onDelete={(chip) => props.deleteChip("noWordExact", chip)}
          newChipKeyCodes={[9, 13, 32]}
          label={t("search_bar_no_words")}
        />
      </FormControl>
    );
  };

  const filters = {
    default: !props.isMobile ?
    [
      taxonomyFilter,
      categoriesFilter,
      liveDraftFilter,
      languagesFilter,
      documentTypeFilter,
      anyWordExact,
    ] 
    :
    [
      taxonomyFilter,
      // categoriesFilter,
      // documentTypeFilter,
    ],
    expanded: !props.isMobile ?
    [
      createdDateRangeStart,
      createdDateRangeEnd,
      lastModifiedDateRangeStart,
      lastModifiedDateRangeEnd,
      allWordExact,
      exactPhrase,
      noWordExact,
    ]
    :
    [
      categoriesFilter,
      documentTypeFilter,
      liveDraftFilter,
      languagesFilter,
      anyWordExact,
      createdDateRangeStart,
      createdDateRangeEnd,
      lastModifiedDateRangeStart,
      lastModifiedDateRangeEnd,
      allWordExact,
      exactPhrase,
      noWordExact,
    ],
  };

  const expandedfilters = () => {
    return filters.expanded.map((filterItem, idx) => {
      return (
        <>
          <Grid item key={idx}>
            {filterItem()}
          </Grid>
        </>
      );
    });
  };

  const defaultFilters = (small) => {
    return filters.default.map((filterItem, idx) => {
      return (
        <>
          <Grid item key={idx}>
            {filterItem(small)}
          </Grid>
        </>
      );
    });
  };

  const activeFilters = () => {
    return null;
  };

  return (
    <Media
      queries={{
        small: "(max-width: 599px)",
        medium: "(min-width: 600px) and (max-width: 1199px)",
        large: "(min-width: 1200px)",
      }}
    >
      {(matches) => (
        <Paper classes={{ root: classes.paperRoot }}>
          <div
            style={{
              display: "flex",
              flexDirection: matches.small ? "column" : "row",
            }}
          >
            <IconButton
              id="reset-search-filters"
              onClick={props.resetToDefault}
              color={props.filtersChanged ? "secondary" : "default"}
              disabled={!props.filtersChanged}
              aria-label="Reset search filters"
            >
              <Icon
                path={
                  props.filtersChanged
                    ? mdiFilterVariantRemove
                    : mdiFilterVariant
                }
                size={1.5}
              />
            </IconButton>
            <Grid
              container
              spacing={2}
              align="center"
              justifyContent="center"
              className={classes.grid}
              style={{ width: "100%" }}
            >
              {defaultFilters(matches.small)}
              {activeFilters()}
            </Grid>

            <div
              style={{
                marginLeft: "auto",
                display: "flex",
                alignItems: "center",
              }}
            >
              <IconButton
                id="search-filter-expand"
                aria-label={
                  expanded ? "Show less filters" : "Show more filters"
                }
                onClick={() => setExpanded(!expanded)}
              >
                {expanded ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </IconButton>
            </div>
          </div>
          <Collapse in={expanded}>
            <Grid
              container
              spacing={2}
              align="center"
              justifyContent="center"
              className={classes.grid}
              style={{ flexDirection: props.isMobile && "column"}}
            >
              {expandedfilters()}
            </Grid>
          </Collapse>
        </Paper>
      )}
    </Media>
  );
}
const mapStateToProps = (state) => ({
  isMobile: state.screen.isMobile,
});

const mapDispatchToProps = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SearchFilters);
